// extracted by mini-css-extract-plugin
module.exports = {"forbes-banner":"forbes-banner_forbes-banner__1zYXc"};